<template>
  <div class="modern-notice">
    <div class="notice-container">
      <div class="notice-icon">
        <i class="el-icon-mic"></i>
      </div>
      <div class="notice-content">
        <!-- 加载状态 -->
        <div v-if="loading" class="notice-text" style="color:rgba(255,255,255,0.6);">
          <i class="el-icon-loading" style="margin-right:6px;"></i>
          加载公告中...
        </div>
        <!-- 有数据时显示轮播 -->
        <transition v-else-if="noticeList.length > 0" name="slide-fade" mode="out-in">
          <div 
            class="notice-text" 
            :key="currentNotice.id"
            @click="goToDetail(currentNotice.id)"
            :title="currentNotice.val"
          >
            {{ currentNotice.val }}
          </div>
        </transition>
        <!-- 加载完成后无数据 -->
        <div v-else class="notice-text" style="color:rgba(255,255,255,0.5);cursor:default;">
          暂无公告
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getNotice } from '../api/all'
export default {
  name: 'ModernNotice',
  data() {
    return {
      noticeList: [],
      number: 0,
      isMobile: null,
      loading: true
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  computed: {
    currentNotice() {
      if (this.noticeList.length === 0) {
        return { id: null, val: '' }
      }
      return {
        id: this.noticeList[this.number]?.id || null,
        val: this.noticeList[this.number]?.title || ''
      }
    }
  },
  mounted() {
    this.getNoticeList() // 自动调用 /list_notices
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
    },
    startMove() {
      if (this.moveTimer) {
        clearTimeout(this.moveTimer)
        this.moveTimer = null
      }
      
      const timer = setTimeout(() => {
        if (this.noticeList.length > 0) {
          this.number = (this.number + 1) % this.noticeList.length
        }
        this.moveTimer = setTimeout(() => {
          this.startMove()
        }, 3000)
      }, 3000)
      this.moveTimer = timer
    },
    async getNoticeList() {
      this.loading = true
      try {
        const res = await getNotice() // 调用 /list_notices
        if (res.status === 1 && res.data && res.data.length > 0) {
          this.noticeList = res.data
          this.number = 0
          this.$nextTick(() => {
            this.startMove()
          })
        } else {
          this.noticeList = []
        }
      } catch (error) {
        console.error('获取公告失败:', error)
        this.noticeList = []
      } finally {
        this.loading = false
      }
    },
    goToDetail(id) {
      if (id) {
        this.$router.push({
          path: '/news-detail',
          query: { id: id }
        })
      }
    }
  }
}
</script>

<style scoped>
.modern-notice {
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  border-radius: 10px;
  padding: 12px 20px;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  width: 100%;
  box-sizing: border-box;
}

.notice-container {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.notice-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  background: rgba(255,255,255,0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notice-icon i {
  color: white;
  font-size: 16px;
}

.notice-content {
  flex: 1;
  overflow: hidden;
  height: 24px;
  position: relative;
  width: calc(100% - 44px);
}

.notice-text {
  position: absolute;
  width: 100%;
  font-size: 14px;
  color: white;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 24px;
  cursor: pointer;
  transition: color 0.3s ease;
}

.notice-text:hover {
  color: #FFCB63;
}

.el-icon-loading {
  animation: rotating 1s linear infinite;
}

@keyframes rotating {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-in;
}

.slide-fade-enter {
  transform: translateY(10px);
  opacity: 0;
}

.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

@media screen and (max-width: 768px) {
  .modern-notice {
    padding: 10px 15px;
    border-radius: 8px;
  }
  
  .notice-container {
    gap: 10px;
  }
  
  .notice-icon {
    width: 28px;
    height: 28px;
  }
  
  .notice-icon i {
    font-size: 14px;
  }
  
  .notice-content {
    height: 20px;
    width: calc(100% - 38px);
  }
  
  .notice-text {
    font-size: 12px;
    line-height: 20px;
  }
}

@media screen and (min-width: 769px) {
  .modern-notice {
    min-width: 350px;
  }
}
</style>